class AtualizarCertificadosModal {
    constructor(api) {
        this.api = api
    }

    async $onInit() {
        this.loadPromise = this.load()
    }

    async load() {
        let {data: {certificados}} = await this.api.get('/certificados-vencidos', {until: 15})

        this.certificados = certificados.map(e => ({...e, contrato_id: e.empresa_id}))
    }
}

angular.module('eficienciaFiscalModule')
    .component('atualizarCertificadosModal', {
        controller: ['api', AtualizarCertificadosModal],
        bindings: {
            close: '&'
        },
        template: `
            <div class="modal-header">
                <h3 class="modal-title">
                    Certificados A1
                    <i class="fa fa-times pull-right cursor-pointer" tooltip="Fechar" ng-click="$ctrl.close()"></i>
                </h3>
            </div>
            <div class="modal-body">
                <loading promise="$ctrl.loadPromise">
                    <highlighted>
                        <main>
                            <ng-pluralize 
                                count="$ctrl.certificados.length"
                                when="{'0': 'Não existem certificados a vencer nos próximos 15 dias.',
                                       'one': 'O certificado da empresa abaixo está expirado ou prestes a vencer.',
                                       'other': 'Os certificados das empresas abaixo estão expirados ou prestes a vencer.'}"
                            ></ng-pluralize>
                        </main>
                        <secondary>
                            Mantenha o certificado sempre atualizado para poder utilizar 100% do seu plano contratado.
                        </secondary>
                    </highlighted>
                    <div ng-if="$ctrl.certificados.length > 0">
                        <ul style="list-style: none; padding: 0 30px; margin: 20px 0 30px">
                            <li ng-repeat="certificado in $ctrl.certificados">
                                <atualizacao-certificado certificado="certificado"></atualizacao-certificado>
                            </li>
                        </ul>
                    </div>
                </loading>
            </div>
            <div class="modal-footer">
                <button class="btn btn-default" ng-click="$ctrl.close()">Fechar</button>
            </div>
        `
    })
